import Button from "../form/Button";
import Modal from "../layout/Modal";

import { useStorageLimitExceededStore } from "@/stores/storageLimitExceeded.store";

export function StorageLimitExceededModal() {
  const { isOpen, close } = useStorageLimitExceededStore();

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(v) => { if (!v) close(); }}
      title="Limit przestrzeni dyskowej"
    >
      <p className="text-secondary mb-6">
        Osiągnięto limit przestrzeni dyskowej dla Twojego planu. Usuń
        niepotrzebne pliki lub zmień plan na wyższy, aby kontynuować.
      </p>

      <div className="grid grid-cols-1 gap-3">
        <Button variant="secondary" onClick={close}>
          Zamknij
        </Button>
      </div>
    </Modal>
  );
}
